import {Environment} from './environment.interface';

export const environment: Environment = {
  envName: 'staging', // Per ECLAIM-165 we are now using this property in the app.component.ts as well. If this ever changes we need to modify that logic as well.
  dynatraceUrl: 'https://js-cdn.dynatrace.com/jstag/147f273fa2a/bf63206omp/5029a61a401f0264_complete.js',
  walkmeUrl: 'https://cdn.walkme.com/users/6e072cd3dd7647aabff33cbd89488f9a/test/walkme_6e072cd3dd7647aabff33cbd89488f9a_https.js',
  production: true,
  apiUrl: 'https://api-staging.vspglobal.com',
  applicationUrl: 'https://eclaim-stg.eyefinity.com/secure',
  consumerUrl: 'https://api-edge-staging.eyefinity.com',
  generalTablesUrl: 'https://api-acpt.vsp.com',
  doctorUrl: 'https://doctor-a7.vsp.com',
  modernEyefinityUrl: 'https://portal-staging.eyefinity.com',
  changePasswordUrl: 'https://sso-stg.vspvision.com/ext/pwdchange/Identify?AdapterId=VspEcpAdapter&pf.username=',
  footerLinksUrl: 'https://www.eyefinity.com',
  eligibilityUrl: 'https://api-staging.vspglobal.com',
  trueLoginUrl: 'https://secure-acceptb.eyefinity.com',
  newTrueFarmLogin: 'https://portal-staging.eyefinity.com/secure-welcome',
  oauthBase: 'api-staging',
  showBuildNumbers: false,
  clientId: 'vsp-eclaim-ui',
  gtmAccountNum: 'GTM-MZMCJWK',
  siteKey: '6Le1kCodAAAAAAVZI-2VnFc_lQJJKLZeSPXmm0t0',
  fulfillmentApiUrl: 'https://api-staging.eyefinity.com/alacpt-client-fulfillment',
  swapApiDomainFrom: 'api-staging.vspglobal.com',
  swapApiDomainTo: 'api-edge-staging.eyefinity.com'
};
